import moment from 'moment'

/**
 * @dateTime parameter pertama saat dipanggil yang menunjukan waktu/tanggal (2020-03-12 12:00:00)
 *
 * @format fungsi untuk mengatur format dari datetime, ex: (YYYY-MM-DD HH:MM:SS)
 *
 * formatDateTime(dateTime, format), komponen stateless untuk menampilkan / mengubah format tanggal.
 *
 *  ex. formatDateTime(2020-03-12 12:00:00, YYYY-MM-DD HH:MM:SS)
 */

export const formatDateTime = (dateTime, format) => {
  let text = ''
  let dateTimeUnix = ''
  dateTimeUnix = dateTime && moment.unix(dateTime).utcOffset(0)
  const dateStr = moment(dateTime)

  const validDate = moment(dateTimeUnix, moment.ISO_8601).isValid() ? dateTimeUnix : dateStr

  const dateTimeLocal = new Date(validDate)
  text = moment(dateTimeLocal).format(format)

  return text
}

const prevmidnight = moment(
  moment()
    .utcOffset(7)
    .subtract(1, 'd')
    .format('YYYY-MM-DD 23:59:00')
)

const midnight = moment(
  moment()
    .utcOffset(7)
    .format('YYYY-MM-DD 23:59:00')
)

const tomorrowMidnight = moment(
  moment()
    .utcOffset(7)
    .add(1, 'd')
    .format('YYYY-MM-DD 23:59:00')
)

/**
 *
 * @startTime parameter pertama pada saat function dipanggil, ex.2020-02-12 00:00:01
 *
 * @endTime data yang dipanggil, ex.2020-02-12 23:59:59
 *
 * export const isToday = (startTime, endTime): komponen stateless untuk mendeklarasikan variable matchStartTime waktu sekarang,
 * variable tersebut akan mengecek startTime, jika ada data maka akan di convert ke utc.
 *
 * @startTimeToday memeriksa matchStartTime sudah tengah malam atau sebelum malam
 *
 * @EndTimeToday memeriksa matchEndTime sudah melewati tengah malam atau sebelum tengah malam
 *
 * ex.isToday(2020-02-12 00:00:01, 2020-02-12 02:00:01)
 *
 * ex.jika salah satu dari var startTimeToday dan endTimeToday bernilai true, maka keluaran yang dihasilkan true
 *
 * ex. jika salah satu dari var startTimeToday dan endTimeToday bernilai False, maka keluaran yang dihasilkan false
 */

export const isToday = (startTime, endTime) => {
  let matchStartTime = startTime && moment.unix(startTime).utcOffset(0)
  let matchEndTime = endTime && moment.unix(endTime).utcOffset(0)
  const startTimeToday = moment(matchStartTime).isAfter(prevmidnight) && moment(matchStartTime).isBefore(midnight)
  const endTimeToday = moment(matchEndTime).isAfter(prevmidnight) && moment(matchEndTime).isBefore(midnight)

  if (startTimeToday || endTimeToday) {
    return true
  }
  return false
}


/**
 * @startTime parameter saat pertama function dipanggil (waktu sekarang), ex: 2020-02-12 00:00:01
 *
 * export const isTommorow = startTime, komponen stateless untuk mendeklarasikan variabel matchTime.
 *
 * ex. isTomorrow = 2020-02-13 00:00:01,
 *
 * function ini akan membandingkan variable startTime sudah melewati tengah malam hari ini dan sebelum tengah malam besok.
 *
 * jika sudah keluaran yang dihasilkan true, jika belum false
 *
 */

export const isTomorrow = startTime => {
  let matchTime = startTime && moment.unix(startTime).utcOffset(0)
  if (moment(matchTime).isAfter(midnight) && moment(matchTime).isBefore(tomorrowMidnight)) {
    return true
  }
  return false
}


/**
 * @endTime = parameter saat pertama function dipanggil (waktu sekarang), ex: 12/03/2020 00:00:01,
 *
 * @isTimePassed = endTime, komponen stateless untuk mendeklarasikan waktu yang telah lewat.
 *
 * ex. isTimePassed = 2020-03-12 00:00:21
 *
 * function ini akan mengecek matchTime sudah lewat atau belum,
 *
 * jika sudah maka akan memiliki nilai True
 *
 * jika belum maka akan memiliki nilai false
 */

//nanti ganti penamaan jadi isTimePassed aja biar lebih global
export const isMatchPassed = endTime => {
  let matchTime = endTime && moment.unix(endTime).utcOffset(0)
  if (moment(matchTime).isBefore()) {
    return true
  }
  return false
}

/**
 * @startTime parameter saat pertama function dipanggil (waktu sekarang), ex. 2020-03-30, 00:00:01
 *
 * @endTime data yang dipanggil, ex.12-02-2020 02:00:01
 *
 * isLive = (startTime, endTime), komponen stateless untuk mendeklarasikan variable matchStartTime yang sedang berlangsung
 *
 * ex. isMatchLive = (2020-03-30 00:001, 12-02-2020 02:00:01)
 *
 * jika variable startTime dan EndTime bernilai True sama maka True
 *
 * Jika salah satu variable bernilai false, maka akan bernilai false
 */


//nanti ganti penamaan jadi isLive aja biar lebih global
export const isMatchLive = (startTime, endTime) => {
  // let endDateTime = formatDateTime(endTime, 'HH:mm')
  // let startDateTime = formatDateTime(startTime, 'HH:mm')
  // let currentTime = moment().format('HH:mm')
  let currentTime = Date.now() / 1000
  if (currentTime >= startTime && currentTime <= endTime) {
    return true
  }
  return false
}

/**
 *
 * @dateTime  Tipe data yang menunjukan waktu/tangal (ex. Live Now)
 *
 * @duration  durasi film/video, contohnya (ex. 30 mins.)
 *
 * @type  variabel format untuk match/video, (ex. match, channel, highlight)
 *
 * addDateTime = (dateTime, duration, type), komponen stateless untuk menambahkan waktu, durasi dan tipe match ke objek (redux)
 *
 * ex.addDateTime (12:03:2020 00:00:01, 180, match)
 */


export const addDateTime = (dateTime, duration, type) => {
  let dt = dateTime ? moment(dateTime) : moment()
  return dt.add(duration, type)
}

const selectedMidnight = compareDateTime => {
  const result = compareDateTime
    ? moment(
      moment(compareDateTime)
        .utcOffset(7)
        .format('YYYY-MM-DD 23:59:00')
    )
    : moment(
      moment()
        .utcOffset(7)
        .format('YYYY-MM-DD 23:59:00')
    )
  return result
}

const selectedPrevmidnight = compareDateTime => {
  const result = compareDateTime
    ? moment(
      moment(compareDateTime)
        .utcOffset(7)
        .subtract(1, 'd')
        .format('YYYY-MM-DD 23:59:00')
    )
    : moment(
      moment()
        .utcOffset(7)
        .subtract(1, 'd')
        .format('YYYY-MM-DD 23:59:00')
    )
  return result
}

/**
 * @selectedDateTime = variable waktu yang dipilih atau function yang di panggil, sekarang ex.12-03-2020 00:00:01
 *
 * @compareDateTime = variable data yang dipanggil sebagai pembanding, ex.12-02-2020 02:00:01
 *
 * @isSameDay = (12-03-2020 00:00:01, 12-02-2020 02:00:01) , komponen stateless untuk mendeklarasikan variable isAfter dan isBefore,
 * tujuannya untuk membandingkan bahwa variable yang dipilih adalah hari yang sama
 *
 * ex. jika kedua variable isAfter dan isBefore bernilai true, maka keluaran yang dihasilkan true
 *
 * ex. jika salah satu variable isAfter atau isBefore bernilai False, maka keluaran yang dihasilkan false
 */


//example: selectedDate = 20 Juni, compare Date = 22 Juni
//result: false
//example: selectedDate = 20 Juni, compare Date = 20 Juni
//result: true
export const isSameDay = (selectedDateTime, compareDateTime) => {
  let dt = selectedDateTime && moment.unix(selectedDateTime).utcOffset(0)
  let cdt = compareDateTime && moment.unix(compareDateTime).utcOffset(0)
  const isAfter = moment(cdt).isAfter(selectedPrevmidnight(dt))
  const isBefore = moment(cdt).isBefore(selectedMidnight(dt))
  if (isAfter && isBefore) {
    return true
  }
  return false
}

/**
 * @startTime = parameter saat pertama function dipanggil (waktu sekarang), ex: 2020-02-12 00:00:01
 *
 * @isLastWeek = startTime , komponen stateless untuk mendeklarasikan variable lastweek dan weekValidate sudah sama dengan 1 minggu sebelumnya
 *
 * ex. isLastWeek = (2020-20-12 00:00:01)
 *
 * function ini akan memvalidasi apakah lastweek sudah sama dengan weekValidate,
 *
 * jika sudah maka akan memiliki nilai true
 *
 * jika belum maka akan memiliki nilai false
 */


export const isLastWeek = startTime => {
  let thisWeek = moment()
    .isoWeekday(1)
    .week() // now

  let lastWeek = thisWeek === 1 ? 52 : thisWeek - 1

  let strTime = moment.unix(startTime)
  let weekValidate = moment(strTime)
    .isoWeekday(1)
    .week()

  if (lastWeek === weekValidate) {
    return true
  }
  return false
}

/**
 * @startTime = parameter saat pertama function dipanggil (waktu sekarang), ex: 2020-02-12 00:00:01
 *
 * @thisWeek = startTime, komponen stateless untuk mendeklarasikan variable lastweek dan weekValidate sudah sama dengan minggu saat ini
 *
 * isThisWeek = (2020-20-12 00:00:01)
 *
 * function ini akan memvalidasi apakah thisWeek sudah sama dengan weekValidate,
 *
 * jika sudah maka akan memiliki nilai true
 *
 * jika belum maka akan memiliki nilai false
 */


export const isThisWeek = startTime => {
  let thisWeek = moment()
    .isoWeekday(1)
    .week() // now

  let strTime = moment.unix(startTime)
  let weekValidate = moment(strTime)
    .isoWeekday(1)
    .week()

  if (thisWeek === weekValidate) {
    return true
  }
  return false
}

/**
 * @startTime = parameter saat pertama function dipanggil (waktu sekarang), ex: 2020-02-12 00:00:01
 *
 * @thisWeek = startTime, komponen stateless untuk mendeklarasikan variable nextweek dan weekValidate sudah sama dengan 1 minggu setelah minggu saat ini
 *
 * function ini akan memvalidasi apakah nextWeek sudah sama dengan weekValidate,
 *
 * jika sudah maka akan memiliki nilai true
 *
 * jika belum maka akan memiliki nilai false
 */


export const isNextWeek = startTime => {
  let thisWeek = moment()
    .isoWeekday(1)
    .week() // now

  let nextWeek = thisWeek === 52 ? 1 : thisWeek + 1

  let strTime = moment.unix(startTime)
  let weekValidate = moment(strTime)
    .isoWeekday(1)
    .week()

  if (nextWeek === weekValidate) {
    return true
  }
  return false
}

export const isMoreThan24Hours = (startTime) => {
  const currentTime = moment();
  const timeStore = moment(startTime);

  const diff =  currentTime.diff(timeStore, 'h')
  console.log({diff})
  if(diff >= 24) {
    return true
  }
  return false
}

